<template>
    <div>
        <el-breadcrumb>
            <el-breadcrumb-item style="font-weight: bolder">交易对平均买入成本</el-breadcrumb-item>
        </el-breadcrumb>
        <br><br>
        <el-form :model="condition" label-width="150px" :inline="true" ref="conForm">
            <el-form-item label="交易对：" prop="pair" :rules="[{required: true, message: '请输入交易对', trigger: 'blur'}]">
                <el-input v-model="condition.pair"></el-input>
            </el-form-item>
            <el-form-item label="交易时间：" prop="time" :rules="[{required: true, message: '请输入交易时间', trigger: 'blur'}]">
                <el-date-picker v-model="condition.time" type="datetimerange" range-separator="至"
                                start-placeholder="开始时间" end-placeholder="结束时间"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="pageNo = 1,querySubmit()">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="exportData()">数据导出</el-button>
            </el-form-item>
        </el-form>

        <el-row>
            <el-col :span="20">
                <el-table :data="avgCostList">
                    <el-table-column prop="userId" label="用户ID" align="center"></el-table-column>
                    <el-table-column prop="amount" label="平均价格" align="center"></el-table-column>
                </el-table>
            </el-col>
        </el-row>

        <br>
        <el-row>
            <el-col :span="12">
                <el-pagination background layout="prev, pager, next" :total="totalAvgCost" :page-size="25"
                               :current-page="pageNo"
                               @current-change="changePage"></el-pagination>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    import '../store';
    import {mapState, mapActions} from 'vuex';

    export default {
        name: "avgCost",

        data() {
            return {
                condition: {
                    pair: '',
                    time: []
                },
                pageNo: 1
            }
        },

        computed: {
            ...mapState('tradeStatistic', ['avgCostList', 'totalAvgCost'])
        },

        created() {
            let time = new Date();
            let year = time.getFullYear();
            let month = time.getMonth();
            let day = time.getDate();
            this.condition.time[0] = new Date(year, month, day, 0, 0, 0);
            this.condition.time[1] = new Date(year, month, day, 23, 59, 59);
        },

        methods: {
            ...mapActions('tradeStatistic', ['getTradeAvgCostInfo', 'exportTradeAvgCost']),
            querySubmit() {
                this.$refs['conForm'].validate(valid => {
                    if (valid) {
                        let data = {
                            pair: this.condition.pair,
                            startTime: this.condition.time[0],
                            endTime: this.condition.time[1],
                            page: this.pageNo
                        }
                        this.getTradeAvgCostInfo(data);
                    }
                })
            },

            changePage(pageNo) {
                this.pageNo = pageNo;
                this.querySubmit();
            },

            exportData() {
                this.$refs['conForm'].validate(valid => {
                    if (valid) {
                        let data = {
                            pair: this.condition.pair,
                            startTime: this.condition.time[0],
                            endTime: this.condition.time[1],
                        };

                        this.exportTradeAvgCost(data).then(response => {
                            const fileName = "平均买入成本统计表" + this.condition.time[0] + "-" + this.condition.time[1] + ".xlsx";
                            const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                            if ('download' in document.createElement('a')) {
                                const link = document.createElement('a');
                                link.download = fileName;
                                link.style.display = 'none';
                                link.href = URL.createObjectURL(blob);
                                document.body.appendChild(link);
                                link.click();
                                URL.revokeObjectURL(link.href);
                            } else {
                                navigator.msSaveBlob(blob, fileName);
                            }
                        })
                    }
                })
            }
        }

    }
</script>

<style scoped>

</style>